import { Container, Typography, Box, Divider } from "@mui/material";

const Section = ({ title, children }) => (
  <Box sx={{ mb: 4 }}>
    <Typography variant="h6" gutterBottom fontWeight={600}>
      {title}
    </Typography>
    {children}
  </Box>
);

const P = ({ children }) => (
  <Typography variant="body1" paragraph color="text.secondary">
    {children}
  </Typography>
);

export const PrivacyPolicy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" fontWeight={700} gutterBottom>
        Privacy Policy
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
        Last updated: May 18, 2026
      </Typography>
      <Divider sx={{ mb: 4 }} />

      <Section title="1. Introduction">
        <P>
          This Privacy Policy describes how we collect, use, and protect your personal
          information when you use our family blog platform ("Service"). By using the
          Service, you agree to the practices described in this policy.
        </P>
      </Section>

      <Section title="2. Information We Collect">
        <P>
          <strong>Phone Number:</strong> We collect your phone number to verify your
          identity via SMS and to associate your account with a group. Your phone number
          is used as your primary identifier.
        </P>
        <P>
          <strong>Name:</strong> We store your name as provided by the group administrator
          to display alongside your posts and comments.
        </P>
        <P>
          <strong>Content:</strong> Any posts, comments, and photos you submit through
          the Service are stored and displayed to members of your group.
        </P>
        <P>
          <strong>Device Information:</strong> If you choose to trust a device, your
          phone number is stored locally in your browser to keep you logged in. This
          data never leaves your device.
        </P>
      </Section>

      <Section title="3. How We Use Your Information">
        <P>We use the information we collect to:</P>
        <ul>
          <li><Typography variant="body1" color="text.secondary">Verify your identity via SMS</Typography></li>
          <li><Typography variant="body1" color="text.secondary">Display your name alongside your posts and comments</Typography></li>
          <li><Typography variant="body1" color="text.secondary">Associate your content with your group</Typography></li>
          <li><Typography variant="body1" color="text.secondary">Send you SMS verification codes when you sign in</Typography></li>
        </ul>
        <P>We do not sell, rent, or share your personal information with third parties for marketing purposes.</P>
      </Section>

      <Section title="4. Third-Party Services">
        <P>
          We use the following third-party services to operate the platform:
        </P>
        <ul>
          <li>
            <Typography variant="body1" color="text.secondary">
              <strong>Firebase (Google):</strong> Authentication, database storage, and
              file hosting. Your data is stored on Google's infrastructure. See Google's
              privacy policy at privacy.google.com.
            </Typography>
          </li>
          <li>
            <Typography variant="body1" color="text.secondary">
              <strong>Google reCAPTCHA:</strong> Used invisibly during sign-in to protect
              against automated abuse.
            </Typography>
          </li>
        </ul>
      </Section>

      <Section title="5. Data Retention">
        <P>
          Your account data is retained for as long as your group subscription is active.
          Posts and comments are retained until deleted by a group administrator. If you
          wish to have your personal information removed, contact your group administrator
          or reach out to us directly.
        </P>
      </Section>

      <Section title="6. Security">
        <P>
          We use industry-standard practices to protect your information, including
          encrypted connections (HTTPS) and Firebase's built-in security rules. However,
          no method of transmission over the internet is 100% secure.
        </P>
      </Section>

      <Section title="7. Children's Privacy">
        <P>
          The Service is not directed to children under 13. We do not knowingly collect
          personal information from children under 13 without parental consent.
        </P>
      </Section>

      <Section title="8. Changes to This Policy">
        <P>
          We may update this Privacy Policy from time to time. We will notify group
          administrators of significant changes. Continued use of the Service after
          changes constitutes acceptance of the updated policy.
        </P>
      </Section>

      <Section title="9. Contact">
        <P>
          If you have questions about this Privacy Policy, please contact the group
          administrator or reach out via the contact information provided when you
          joined your group.
        </P>
      </Section>
    </Container>
  );
};
